/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import { Button, Card, Group, Text } from "@mantine/core";
import { useDisclosure, useForceUpdate } from "@mantine/hooks";
import { IconFilter, IconPlus } from "@tabler/icons-react";
import { useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";
import AddItemButton from "@/components/add-item-button";
import RefreshQueryButton from "@/components/refresh-query-button";
import { THandler } from "@/components/table/Table";
import FilterList from "@/components/table/TableFiltersList";
import { useGetAuthorizations } from "@/hooks/useGetAuthorizations";
import ProjetosTable from "@/modules/projetos/components/projetos-table";
import { QUERY_KEY } from "@/modules/projetos/components/projetos-table/ProjetosTable";
import projetoSchema from "@/modules/projetos/schema/projeto-schema";
import { ID_CADASTROS_PROJETOS } from "@/utils/constants";
import TableFilters from "./TableFilters";

const REFRESH_ALL_KEY = [QUERY_KEY];

const ProjetosPage = () => {
  const { create } = useGetAuthorizations(ID_CADASTROS_PROJETOS);

  const queryClient = useQueryClient();
  const forceUpdate = useForceUpdate();

  const tableHandlersReference = useRef<THandler<TProjeto>>(null);

  const [opened, { close, toggle }] = useDisclosure(false);

  const handleFilterApplied = () => {
    close();
    void queryClient.invalidateQueries({ queryKey: REFRESH_ALL_KEY }).then(() => forceUpdate());
  };

  return (
    <Card
      withBorder
      shadow="md"
      styles={{
        section: {
          overflow: "auto"
        }
      }}
    >
      <Card.Section px="md" py="xs" withBorder>
        <Group justify="space-between">
          <Text fw={500} fz="lg">
            Listagem de Projetos
          </Text>
          {create && (
            <Group>
              <AddItemButton
                size="sm"
                leftSection={<IconPlus size="1rem" />}
                modalProperties={{ modal: "projeto-form-modal" }}
                schema={projetoSchema}
              >
                Adicionar
              </AddItemButton>
            </Group>
          )}
        </Group>
      </Card.Section>
      <Card.Section inheritPadding py="md" withBorder>
        <Group justify="space-between">
          <Group align="center">
            <Button variant="subtle" size="compact-md" onClick={toggle} leftSection={<IconFilter size="1rem" />}>
              Filtros
            </Button>
            {tableHandlersReference.current && <FilterList filters={tableHandlersReference.current.filters} />}
          </Group>
          <RefreshQueryButton queryKey={REFRESH_ALL_KEY} />
        </Group>

        {tableHandlersReference.current && (
          <TableFilters
            table={tableHandlersReference.current.table}
            filters={tableHandlersReference.current.filters}
            onClose={close}
            onFilterApplied={handleFilterApplied}
            opened={opened}
          />
        )}
      </Card.Section>
      <ProjetosTable ref={tableHandlersReference} />
    </Card>
  );
};

ProjetosPage.displayName = "ProjetosPage";

export default ProjetosPage;
